import React, { useState, useEffect } from 'react';
import { Route, Switch} from 'react-router-dom';

import './profesionales.scss';

import AltaProfesionalesForm from './AltaProfesionalForm';
import ProfesionalesList from './ProfesionalesList.js';
import apifunctions from '../../components/Tienda/api/functions.js';

export const apiprofesionales = {
	profesionales : process.env.REACT_APP_RANGO_PROFESIONALES + "profesionales/",
	categorias : process.env.REACT_APP_RANGO_PROFESIONALES + "categorias/"
}

const Profesionales = () => {

	const [categorias, setCategorias] = useState([]);

	const updateCategorias = () => {
		let parameters = {
			fields: ['id','nombre'],
			pageSize: 99,
			sort: ["nombre"]
		}

		apifunctions.get(
			apiprofesionales.categorias,
			null,
			null,
			parameters,
			data => {
				if (data && data.data && data.data.length > 0){
					setCategorias(data.data)
				}
			},
			()=>{},
			()=>{}
		);
	}

	useEffect(updateCategorias, []);

	return (
		<>
			<section className="bgTitle bgProfesionales py-10">
				<div className="container">
					<div className="row">
						<div className="col-sm-5">
							<h2>ENCUENTRE EL MEJOR PROFESIONAL</h2>
							<h3>PARA SU PROYECTO</h3>
						</div>
					</div>
				</div>
			</section>
			<section>
			<Switch>
                <Route path="/profesionales/form" render={() => <AltaProfesionalesForm categorias={categorias} />} />
				<Route path="/profesionales" render={() => <ProfesionalesList categorias={categorias} />} />
			</Switch>
			</section>
		</>
);
}

export default Profesionales;
